// extracted by mini-css-extract-plugin
export var closeButton = "_2z-3";
export var header = "_2z-0";
export var link = "_2z-1";
export var retryButton = "_2z-2";